import {
    Background,
    BackgroundColor,
    Container,
    Grid,
    GridColumns,
    GridGap,
    Spacer,
    SpacerVariant,
    backgroundGreyScaleColorsOptions,
    spacerOptions,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import React from "react"

interface ThreeColumnBigIconTextProps {
    background: { color: BackgroundColor } | BackgroundColor
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
    allwaysColumns: boolean
}

const ThreeColumnBigIconText: types.Brick<ThreeColumnBigIconTextProps> = ({
    background,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
    allwaysColumns,
}) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Container>
                <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
                <Repeater propName="centerText" />
                <Grid columns={GridColumns.Three} gapX={GridGap.Large} allwaysColumns={allwaysColumns} as="ul">
                    <Repeater
                        propName="repeater"
                        itemProps={{ smallIconMobile: allwaysColumns, hideTextMobile: allwaysColumns }}
                    />
                </Grid>
                <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
            </Container>
        </Background>
    )
}

ThreeColumnBigIconText.schema = {
    name: "ThreeColumnBigIconText",
    label: "Big Icon Text (3 Col)",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/3ColumnBigIconText.png`,
    repeaterItems: [
        {
            name: "centerText",
            items: [
                {
                    type: "CenterText",
                    label: "Text",
                    max: 1,
                },
            ],
        },
        {
            name: "repeater",
            items: [
                {
                    type: "ThreeColumnBigIconTextItem",
                    label: "Big Icon Text Item",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundGreyScaleColorsOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            name: "allwaysColumns",
            label: "hide text on mobile, images in row",
            type: types.SideEditPropType.Boolean,
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): ThreeColumnBigIconTextProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
        allwaysColumns: false,
    }),
}

export default ThreeColumnBigIconText
